import styled from 'styled-components/macro';

interface Props {
    color: string;
}

export const MapV2GlassEffectBackground = (props: Props) => {
    return <S_MapV2GlassEffectBackground $color={props.color} />;
};

export const S_MapV2GlassEffectBackground = styled.div<{ $color: string }>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${(props) => props.$color};
    opacity: 0.97;
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(12.1px);
    -webkit-backdrop-filter: blur(12.1px);
    z-index: -1;
`;
